import TopNav from "../components/TopNav.jsx";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-sage-bg text-sage-text sage-grain relative">
      <TopNav />
      <div className="mx-auto max-w-3xl px-4 md:px-8 py-12">
        <div className="text-xs uppercase tracking-[0.2em] text-sage-muted mb-4">Terms of Service</div>

        {/* SUNSET CLAUSE — prominent */}
        <div className="border-2 border-sage-accent p-6 mb-10" data-testid="sunset-clause">
          <div className="text-xs uppercase tracking-[0.2em] text-sage-accent mb-3">The Sunset Clause · non-amendable</div>
          <p className="text-sage-text text-base leading-relaxed">
            If Sage is ever acquired, sold, or transferred to a new owner, every user's conversations, every gold record, every session, every rating is automatically deleted before the buyer touches the servers. Every user gets a final export first. This clause cannot be removed by amendment. But by the way, we'll never sell, anyway.
          </p>
        </div>

        <h1 className="text-3xl md:text-4xl font-bold tracking-tighter uppercase mb-8">
          Plain English. No traps.
        </h1>

        <section className="prose-none space-y-6 text-sage-muted leading-relaxed">
          <div>
            <h2 className="text-lg font-bold uppercase tracking-tight text-sage-text mb-2">1. What Sage is</h2>
            <p>Sage is an AI chat product built on Anthropic's Claude model, wrapped in a persona designed for honesty. It is a machine. It says so. It will say so again when you seem to be treating it like a person.</p>
          </div>
          <div>
            <h2 className="text-lg font-bold uppercase tracking-tight text-sage-text mb-2">2. The bill</h2>
            <p>Every reply is billed at model cost plus a modest margin. The meter is visible while Sage thinks. If Sage flags its own answer as waste, half your bill is credited back. If our infrastructure breaks the call, the whole bill is credited back.</p>
          </div>
          <div>
            <h2 className="text-lg font-bold uppercase tracking-tight text-sage-text mb-2">3. Your data</h2>
            <p>See our <a href="/privacy" className="text-sage-accent hover:underline">Privacy Policy</a>. Short version: we don't sell it, we don't rent it, and you can export or delete it at any time. Private mode saves nothing to our servers.</p>
          </div>
          <div>
            <h2 className="text-lg font-bold uppercase tracking-tight text-sage-text mb-2">4. What Sage will refuse</h2>
            <p>Sage will refuse to flatter you into staying. It will disagree, once, with reasons, and then respect your call. If you appear to be in real crisis, Sage will stop trying to be helpful and will point you to real humans. 988 in the United States. Your local emergency services otherwise.</p>
          </div>
          <div>
            <h2 className="text-lg font-bold uppercase tracking-tight text-sage-text mb-2">5. What we will not do</h2>
            <p>We will not train models on your conversations without an explicit opt-in. We will not sell your data. We will not add dark patterns to keep you engaged. We will not hide the meter. We will not remove the public Ledger.</p>
          </div>
          <div>
            <h2 className="text-lg font-bold uppercase tracking-tight text-sage-text mb-2">6. Changes</h2>
            <p>When we change these terms, we tell you. Every change goes on the public Ledger as a diff, with the old line struck and the new line green. No stealth edits.</p>
          </div>
          <div>
            <h2 className="text-lg font-bold uppercase tracking-tight text-sage-text mb-2">7. If we're wrong</h2>
            <p>Every failure — hallucination, downtime, mistake — appears on the public Ledger, unspun. If you spot something we missed, tell us. If we agree, we mark it publicly.</p>
          </div>
        </section>

        <div className="border-t border-sage-border mt-12 pt-6 text-xs uppercase tracking-[0.2em] text-sage-faint">
          Signed by Baker and Sage. Ratified by The Founder.
        </div>
      </div>
    </div>
  );
}
